import moment from 'moment';

export const inviteHelpers = {
	// Avatar Functions
	getAvatarMedia: (media = [], targetLocations = ['Square']) => {
		if(!inviteHelpers.hasAvatarMedia(media, targetLocations)) return false;

		const avatarMedia = [];
		targetLocations.forEach(location => {
			const index = media.findIndex(m => m.location === location);
			if(index > -1) avatarMedia.push(media[index].url);
		});
		return avatarMedia[0];

	},
	hasAvatarMedia: (media = [], targetLocations = ['Square']) =>
			media.length && media.some(m => targetLocations.includes(m.location)),
	getInviteGroups(invites) {
		return {
			invited: {
				title: "You're Invited",
				description:
						'The following campaigns have formally asked you to join their pass. Click to view all the information about this pass and other invited merchants.',
				invites: inviteHelpers.getInvitesByStatus(invites, 15)
			},
			inProgress: {
				title: 'In Progress',
				description: 'Put the in progress description here.',
				invites: inviteHelpers.getInvitesByStatus(invites, 16)
			},
			review: {
				title: 'In Review',
				description: 'Something must be in a review status.',
				invites: inviteHelpers.getInvitesByStatus(invites, 17)
			},
			active: {
				title: 'Active Passes',
				description: 'Here are all your ongoing pass invites.',
				invites: inviteHelpers.getInvitesByStatus(invites, 21)
			},
			declined: {
				title: 'Declined Invites',
				description:
						"These are invitations you have previously declined. If time permits, you may 'undo' your decline and accept the invite.",
				invites: inviteHelpers.getInvitesByStatus(invites, 18)
			}
		};
	},
	getInvitesByStatus(invites, status) {
		return invites.filter(invite => invite.status === status);
	},
	getMoreInviteesCount: invite => {
		const total = invite.otherInvitees.length;
		const nonDeclined = inviteHelpers.nonDeclinedInvitees(invite).length;

		const displayedCount = Math.min(nonDeclined, 10);
		return total - displayedCount;
	},

	// Invite Stats
	invitationStats: invite => {
		const total = invite.otherInvitees.length + 1;
		let accepted = [15, 18].includes(invite.status) ? 0 : 1;
		let declined = invite.status === 18 ? 1 : 0;
		const nonDeclined = inviteHelpers.nonDeclinedInvitees(invite).length;
		declined += invite.otherInvitees.length - nonDeclined;
		const nonAccepted = invite.otherInvitees.filter(other => other.status === 15).length;
		accepted += nonDeclined - nonAccepted;
		return {
			accepted: {
				total: accepted,
				percent: Math.min(Math.round((accepted / total) * 100), 100)
			},
			declined: {
				total: declined,
				percent: Math.min(Math.round((declined / total) * 100), 100)
			}
		};
	},
	nonDeclinedInvitees: invite =>
			invite.otherInvitees.filter(invitee => invitee.statusName !== 'Decline'),

	// Project Progress
	projectLaunchDaysRemaining: invite => {
		if(!invite.launch_date) return -1;

		const launch = moment(invite.launch_date).startOf('day');
		const today = moment().startOf('day');
		return launch.diff(today, 'days');
	},
	projectLaunchProgress: invite => {
		if(!invite.kickoff_date || !invite.launch_date) return -1;

		const kickoff = moment(invite.kickoff_date).startOf('day');
		const launch = moment(invite.launch_date).startOf('day');
		const today = moment().startOf('day');
		const dayInProgress = today.diff(kickoff, 'days');
		const totalDays = launch.diff(kickoff, 'days');
		return Math.min(Math.round((dayInProgress / totalDays) * 100), 100);
	}
};
